/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Scope_Not_Item_1Inputs */

const es_privacy_policy_scope_not_item_1 = /** @type {(inputs: Privacy_Policy_Scope_Not_Item_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informacion recopilada por sitios web o servicios de terceros enlazados desde nuestra plataforma`)
};

const en_privacy_policy_scope_not_item_1 = /** @type {(inputs: Privacy_Policy_Scope_Not_Item_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Information collected by third-party websites or services linked from our platform`)
};

/**
* | output |
* | --- |
* | "Information collected by third-party websites or services linked from our platform" |
*
* @param {Privacy_Policy_Scope_Not_Item_1Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_scope_not_item_1 = /** @type {((inputs?: Privacy_Policy_Scope_Not_Item_1Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Scope_Not_Item_1Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_scope_not_item_1(inputs)
	return en_privacy_policy_scope_not_item_1(inputs)
});
export { privacy_policy_scope_not_item_1 as "privacy_policy.scope.not_item_1" }